var state = {
  drawerState: false
};
var mutations = {
  DRAWER_STATE: function DRAWER_STATE(state, value) {
    state.drawerState = value;
  }
};
var actions = {
  addErrorLog: function addErrorLog(_ref, log) {
    var commit = _ref.commit;
    commit('ADD_ERROR_LOG', log);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};